import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import ConstructionIcon from '@mui/icons-material/Construction';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import { SpeedDial } from '../../components/SpeedDial';
import {
  PATH_MATERIALS,
  PATH_MATERIALS_NEW,
} from '../../app/constants/paths.constant';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { MaterialList } from '../../components/MaterialList';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

export const MaterialsPage = () => {
  const { setPage } = useNavigationContext();

  useEffect(() => {
    setPage(Page.Materials);
  }, [setPage]);

  return (
    <>
      <Helmet>
        <title>{buildDocumentTitle('Liste des Matériels')}</title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_MATERIALS,
            label: 'matériels',
            key: 'materials',
          },
        ]}
      />
      <PageTitle title="Liste des Matériels" />
      <MaterialList />
      <SpeedDial
        actions={[
          {
            id: 'createMaterial',
            icon: <ConstructionIcon />,
            name: 'Créer Matériel',
            to: PATH_MATERIALS_NEW,
          },
        ]}
        title="Actions possibles sur les Matériels"
      />
    </>
  );
};
